import { render, staticRenderFns } from "./LocationTree.vue?vue&type=template&id=4712f884&scoped=true"
import script from "./LocationTree.vue?vue&type=script&lang=js"
export * from "./LocationTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4712f884",
  null
  
)

export default component.exports